import axios from 'axios';
import API from './API';


export const Test_Connection = () => API.get('Test/Connection');